<template>
  <div class="bg-block rounded p-12 pt-14 shadow-primaryBlock relative">
    <DealsFilters class="mb-14"/>
    <div class="text-xl font-bold text-text leading-tight mb-8">События</div>
    <div v-if="!$store.state.investments.deals.deals.data.length"
         class="text-center text-xl text-text font-medium">
      Ничего не найдено, попробуйте изменить фильтры
    </div>
    <DealsList v-else :deals="$store.state.investments.deals.deals.data" class="mb-12"/>
    <div class="flex items-center bg-bg-to-block-gradient rounded-b
                  -mx-12 -mb-12 lg:-m-12 lg:mt-0
                  px-8 pt-10 pb-10 lg:p-12 lg:pt-15 lg:pb-15"
         v-show="filters.pagination.pages > 1">
      <Pagination :pagination="filters.pagination"
                  @page="setPage"/>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import DealsFilters from "@/components/cabinet/Investments/InvestmentDeals/DealsFilters/DealsFilters";
import DealsList from "@/components/cabinet/Investments/InvestmentDeals/DealsList";
import Pagination from "@/components/UI/Pagination/Pagination";

export default {
  name: "TheInvestmentsDeals",
  components: {Pagination, DealsList, DealsFilters, TopGradientBlockLayout},
  computed: {
    ...mapState('investments/deals', ['filters', 'deals']),
    ...mapState('investments/portfolios', ['current_portfolio'])
  },
  methods: {
    ...mapMutations('investments/deals', ['setPage']),
  },
  mounted() {
    this.$store.dispatch('investments/deals/fetchDealsHistory')
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.$store.dispatch('investments/deals/fetchDealsHistory')
      }
    },
    'current_portfolio.data': {
      deep: true,
      handler() {
        this.$store.dispatch('investments/deals/fetchDealsHistory')
      }
    }
  }
}
</script>